<div class="row p-b-10">
    <div class="col-xs-12">
	<button id="js-global-refresh" class="btn btn-default pull-right">
		<i class="fa fa-refresh"></i>
	</button>
        <h4 class="page-title">{{TR "Smart Detection"}}</h4>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <div class="card-box clearfix">
            {{#if showFilter}}
            {{{FILTER filter}}}
            {{/if}}
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                    <div class="form-group">
                        <label for="rf-priority" class="js-same-height control-label">{{TR "Priorität"}}</label>
                        {{#SELECT rankingFilter.priority}}
                        <select class="selectpicker js-ranking-filter" data-style="btn-white btn-sm" id="rf-priority" name="rf_priority">
                            <option value="0">{{TR "Alle"}}</option>
                            <option value="1">{{TR "Niedrig"}}</option>
                            <option value="2">{{TR "Mittel"}}</option>
                            <option value="3">{{TR "Hoch"}}</option>
                        </select>
                        {{/SELECT}}
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                    <div class="form-group">
                        <label for="rf-rule" class="js-same-height control-label">{{TR "Regel"}}</label>
                        {{#SELECT rankingFilter.rule}}
                        <select class="selectpicker js-ranking-filter-select" multiple="multiple" data-style="btn-white btn-sm" id="rf-rule" name="rf_rule">
                            {{#each rankingFilter.rules}}
                                <option value="{{id}}">{{name}}</option>
                            {{/each}}
                        </select>
                        {{/SELECT}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="ranking-result">
</div>
